import { Typography, Box } from '@mui/material';
function PageTitle ({ title }) {
  return (
    <>
      <Typography
        component={'span'}
        sx={{
          zIndex: 1,
          position: 'relative',
          fontSize: { xl: '1.45rem', xs: '1.2rem' },
          textAlign: 'center',
          fontWeight: 900,
          color: '#000',
          ':first-letter': {
            fontSize: { xl: '2rem', xs: '1.65rem' },
            color: '#0a4fac',
          },
        }}
      >
        {title}
      </Typography>
    </>
  );
}

export default PageTitle;
